export default __webpack_public_path__ + "static/media/85.e1f14bb5.jpeg";